export default {
  "home": {
    "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Discover, stream, and share a constantly expanding mix of music from emerging and major artists around the world."])},
    "listen": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Listen to Great Music!"])},
    "songs": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Songs"])}
  },
  "manage": {
    "my_songs": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["My Songs"])}
  },
  "register": {
    "TOS": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Terms of Service"])},
    "accept": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list } = ctx;return _normalize(["I accept Milo Music's ", _interpolate(_list(0)), "."])}
  },
  "song": {
    "comment_count": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named, plural: _plural } = ctx;return _plural([_normalize(["No comments"]), _normalize(["1 Comment"]), _normalize([_interpolate(_named("count")), " Comments"])])}
  }
}